export default __webpack_public_path__ + "locales/az/VersionHistory.json?hash=3a8950ad163494ffa65ae32fd9160e7f";